import { CompanyListDTO } from './models/company.model';
import { SPIDUser } from './models/SPIDUser.model';
import { SPIDService } from './services/spid.service';
import { AuthService } from './services/auth.service';
import { AddCustomersComponent } from './components/registry/customers/add-customers/add-customers.component';
import { AddProductsComponent } from './components/registry/products/add-products/add-products.component';
import { ComponentMapperService } from './helpers/componentMapper.service';
import { EqpDashboardService } from '@eqproject/eqp-dashboard';
import { Component, HostListener, Inject, OnInit, Renderer2 } from '@angular/core';
import { Router, NavigationEnd, ActivationEnd, ChildActivationEnd } from '@angular/router';
import { licenseKey } from '../devextreme-license';
import { IconSetService } from '@coreui/icons-angular';
import { freeSet } from '@coreui/icons';
import { TranslateService } from '@ngx-translate/core';
import { GlobalService } from './services/global.service';
import { UserService } from './services/user.service';
import i18n_it from "../assets/i18n/i18n_it.json";
import i18n_en from "../assets/i18n/i18n_en.json";
import i18n_fr from "../assets/i18n/i18n_fr.json";
import { DOCUMENT } from '@angular/common';
import { FixTemplateService } from './services/fixtemplate.service';
import { locale, loadMessages } from "devextreme/localization";
import config from 'devextreme/core/config'; 
import { ChangePasswordDTO } from './models/user.model';
import itMessages from "devextreme/localization/messages/it.json";
import enMessages from "devextreme/localization/messages/en.json";
import frMessages from "devextreme/localization/messages/fr.json";

 
config({ 
  licenseKey,
  defaultCurrency: 'EUR'
});  
@Component({
  // tslint:disable-next-line
  selector: 'body',
  template: '<app-spinner></app-spinner><router-outlet></router-outlet>',
  providers: [IconSetService],
})
export class AppComponent implements OnInit {

  //Parametri da passare allo SPID per il recupero utente
  SPIDUser: SPIDUser = new SPIDUser();
  company: CompanyListDTO = new CompanyListDTO();

  constructor(
    private router: Router,
    public iconSet: IconSetService,
    private translate: TranslateService,
    private userService: UserService,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private templateFixService: FixTemplateService,
    private eqpDashboardService: EqpDashboardService,
    private authenticationService: AuthService,
    private spidService: SPIDService) {
    // iconSet singleton
    iconSet.icons = { ...freeSet };
    loadMessages(itMessages);
    loadMessages(enMessages);
    loadMessages(frMessages);
    locale(GlobalService.getSelectedLanguage());
  }

  @HostListener('window:resize', ['$event']) onResize(event) {
    this.templateFixService.fixTemplate(event, this.document, this.renderer);
  }

  ngOnInit() {

    //Redirect da FattureXLS per gestione login automatica
    if (location.href.includes("newFattureToken=") && location.href.includes("clientID=")) {
      let newFattureParam = location.href.split('?')[1].split('&')[0].split('=')[1];
      let newClientIDParam = location.href.split('?')[1].split('&')[1].split('=')[1];
      this.authenticationService.setCurrentToken(newFattureParam);
    }
    // Controlla se abbiamo già processato questo reset
      

    if (location.hash.includes("newFattureToken=") && location.hash.includes("ResetPassword=")) {
      let newFattureParam = location.hash.split('?')[1].split('&')[0].split('=')[1];
      let ResetPassword = location.hash.split('?')[1].split('&')[1].split('=')[1];
      //const resetKey = `resetPassword_${newFattureParam}`;
      //const alreadyProcessed = sessionStorage.getItem(resetKey);
      //this.utilityService.clearQueryParameters(this.route, this.router);
      if (ResetPassword.toLowerCase() === 'true' ) {
      //if (ResetPassword.toLowerCase() === 'true' && !alreadyProcessed) {

        this.authenticationService.setCurrentToken(newFattureParam);
        let dto : ChangePasswordDTO = new ChangePasswordDTO();        
        dto.userID =  this.authenticationService.getCurrentUser().ID;
        // Segna come processato
        //sessionStorage.setItem(resetKey, 'true'); 
        
        this.userService.changePassword(dto).then(() => {
          // Logout dell'utente
          localStorage.clear();
          sessionStorage.removeItem("fattureXlsSelectedCompany");
          
          // Redirect alla pagina di successo
          
        }).catch((error) => {
          console.error('Errore durante il cambio password:', error);
        });
      }
      this.authenticationService.sessionReset();
      this.router.navigate(['/password-changed-success']);
    }

    //Gestione redirect SPID
    if (location.href.includes("sessionid=") && location.href.includes("sessionkey=")) {
      let sessionID = location.href.split('?')[1].split('&')[0].split('=')[1];
      let sessionKey = location.href.split('?')[1].split('&')[1].split('=')[1];
      this.spidService.SPIDAuth(sessionID, sessionKey);
    }

    //Registro i componenti per la lookup
    ComponentMapperService.register('app-add-products', AddProductsComponent);
    ComponentMapperService.register('app-add-customers', AddCustomersComponent);

    this.onResize(this.document.defaultView);

    var self = this;
    self.translate.setDefaultLang(GlobalService.getI18nJson());

    var checkIsValid: boolean = false;

    this.router.events.subscribe((evt) => {
      if (evt instanceof ActivationEnd || evt instanceof ChildActivationEnd) {

        if (self.translate.store && self.translate.store.currentLang) {
          this.initializeLanguage();
        }

        //Controllo se esiste la proprietà disableChangeCompany nel cambio rotta per disabilitare la possibilità
        //di cambiare la company
        if (evt.snapshot && evt.snapshot.data && evt.snapshot.data.disableChangeCompany) {
          checkIsValid = true;
        }
      }

      if (!(evt instanceof NavigationEnd)) {
        return;
      }

      //Se nel navigationEnd checkIsValid è true cambio la variabile presente nel GlobalService e disabilito il cambio company
      if (evt instanceof NavigationEnd) {
        if (checkIsValid == true) {
          GlobalService.changeCurrentCompanyDisable = true;
          checkIsValid = false;
        } else {
          GlobalService.changeCurrentCompanyDisable = false;
        }
      }

      window.scrollTo(0, 0);
    });
  }


  /**
   * Vengono inizializzate le translations, se non disponibili nel LOCALSTORAGE vengono definite di default a IT
   * in questo metodo vengono anche inizializzati gli helper dei componenti esterni per la lingua
   */
  initializeLanguage() {
    if (GlobalService.getSelectedLanguage() == "it") {
      this.translate.setTranslation(GlobalService.getSelectedLanguage(), i18n_it, true);
    }
    else if (GlobalService.getSelectedLanguage() == "fr") {
      this.translate.setTranslation(GlobalService.getSelectedLanguage(), i18n_fr, true);
    } else {
      this.translate.setTranslation(GlobalService.getSelectedLanguage(), i18n_en, true);
    }

    this.translate.use(GlobalService.getSelectedLanguage());

    // Fix: Removed calls to eqpTableService and translateTableHelper to resolve runtime error
    if (GlobalService.getSelectedLanguage() == "it") {
      this.eqpDashboardService.setLocale('it-IT');
    } else if (GlobalService.getSelectedLanguage() == "fr") {
      this.eqpDashboardService.setLocale('fr-FR');
    } else {
      this.eqpDashboardService.setLocale('en-US');
    }
  }

}
